import { useParams } from 'react-router-dom';
import RelationshipTabs from '../components/RelationshipTabs';
import { useAuth } from '../context/AuthContext';
import { useContact } from '../hooks/useContact';

const RelationshipFamilyPage = () => {
  const { id } = useParams();
  const { accessToken } = useAuth();
  const { data: contact, isLoading, isError } = useContact(accessToken, id);

  const fullName = contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() : '';

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-y-auto">
      <div className="sticky top-0 z-20 border-b border-white/5 bg-[#050815] px-4 pb-3 pt-16 sm:px-6 md:px-8 md:pt-10">
        <RelationshipTabs contactId={id} activeKey="family" />
      </div>

      <section className="px-4 py-6 sm:px-6 md:px-8 md:py-10">
        <div className="rounded-2xl border border-white/10 bg-[#0c1428]/90 p-6 shadow-soft">
          {isLoading && <p className="text-sm text-slate-300">Loading contact…</p>}
          {isError && <p className="text-sm text-amber-300">Unable to load contact.</p>}
          {!isLoading && !isError && (
            <p className="text-sm text-slate-200">
              Family details for {fullName || 'this contact'} will appear here.
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default RelationshipFamilyPage;
